import { datadogLogs } from '@datadog/browser-logs';
import { datadogRum, RumResourceEventDomainContext } from '@datadog/browser-rum';

import { CloudContextHeader } from '@labradorsports/constants';
import { cleanStack } from '@labradorsports/utils';

const warningMessages = [
    'Minified React error #421',
    'Minified React error #423',
    'Minified React error #418',
    'This Suspense boundary received an update before it finished hydrating.',
    'Load failed',
    'Fetch is aborted',
    'Loading chunk',
    'Failed to fetch',
    'Request aborted',
    'Uncaught "Timeout"',
    "Stripe.js requires 'allow-same-origin' if sandboxed.",
    'Connection to Indexed Database server lost. Refresh the page to try again',
    '[Termly] A lazily-loaded component failed to load.',
    'Failed to update a ServiceWorker for scope',
    'ResizeObserver loop completed with undelivered notifications.',
    'Database deleted by request of the user',
    "Hydration failed because the server rendered HTML didn't match the client.",
    'Remote Config: The config fetch request timed out.',
    'Remote Config: Fetch client failed to connect to a network.',
    'Ignored attempt to cancel a touchmove event with cancelable=false',
    'Failed to update a ServiceWorker for scope',
    'Permissions check failed',
];

export function initDatadog(site: Site, baseUrl: string) {
    let env = PROD ? 'prod' : 'test';

    if (!DEPLOY) {
        env = 'dev';
    }

    const ddParams = {
        clientToken: 'pub5531b15d4fc7509a3eb70946cc7776dd',
        env,
        site: 'us5.datadoghq.com' as const,
        version: `${VERSION}-${BUILD}`,
        service: `${site}-${APP ? 'native' : 'web'}`,
    };

    datadogRum.init({
        ...ddParams,
        applicationId: '1fc6c26b-4845-45d3-8bcb-08f28f167d69',
        sessionSampleRate: 100,
        sessionReplaySampleRate: 100,
        trackUserInteractions: true,
        trackResources: true,
        trackViewsManually: true,
        beforeSend: (event, context) => {
            if (event.type === 'resource' && event.resource.type === 'fetch') {
                // Add firebase functions trace context
                event.context.traceContext = (context as RumResourceEventDomainContext).response?.headers.get(
                    CloudContextHeader
                );
            }

            if (event.type === 'error') {
                // filter out error that might be caused by link validation/ pre-fetch rendering from email clicks
                // https://github.com/DataDog/browser-sdk/issues/2715
                const regex = /Object Not Found Matching Id:\d+, MethodName:\w+, ParamCount:\d+/;
                if (regex.test(event.error.message)) return false;

                event.error.stack = cleanStack(event.error.stack, baseUrl, false);

                if (
                    !event.error.message ||
                    warningMessages.some(
                        (msg) =>
                            event.error.message.includes(msg) ||
                            (event.error.source === 'console' && event.error.handling_stack?.includes(msg))
                    )
                ) {
                    event.context.errorLevel = 'warn';
                }
            }

            return true;
        },
    });

    datadogLogs.init({
        ...ddParams,
        forwardErrorsToLogs: true,
        forwardConsoleLogs: ['error'],
        sessionSampleRate: 100,
    });
}
